import React from "react";
import { Home } from "./Home";
import ReserveASeat from "../../components/Forms/RSVP/ReserveASeat";
import { Helmet } from "react-helmet";
import { useSelector, shallowEqual } from "react-redux";

export const ReserveASeatPage = () => {
  const secondOrgInfo = useSelector(
    (state) => state.secondOrgInfo.responseData,
    shallowEqual
  );
  return (
    <>
      {secondOrgInfo && (
        <Helmet>
          <title>
            {window.location.pathname.substr(1) === "checkin"
              ? secondOrgInfo.metaData.checkIn.title
              : secondOrgInfo.metaData.rsvp.title}
          </title>
          <meta
            name={
              window.location.pathname.substr(1) === "checkin"
                ? secondOrgInfo.metaData.checkIn.author
                : secondOrgInfo.metaData.rsvp.author
            }
            content={
              window.location.pathname.substr(1) === "checkin"
                ? secondOrgInfo.metaData.checkIn.description
                : secondOrgInfo.metaData.rsvp.description
            }
          />
        </Helmet>
      )}
      <Home>
        <ReserveASeat />
      </Home>
      ;
    </>
  );
};
